<template>
  <div class="ui-content dashboard leader-sub">
    <div class="institute-drop">
      <div class="past-test-dropdown" v-if="showTestTypeDD()">
        <v-select
          @change="updateTestType"
          :items="testTypesList"
          v-model="selectedTest"
          hide-details
        ></v-select>
      </div>
      <div class="past-test-dropdown" v-if="showCumulativeButton()">
        <v-btn depressed color="indigo" @click="gotoCumulativeAnalysis()" class="cumulative-btn">
          Cumulative Analysis
        </v-btn>
      </div>
      <div class="student-dropdown-list" v-if="students.length > 1 && isParent">
        <v-select
          @change="updateSelectedStudent"
          :items="students"
          v-model="selectedStudent"
          hide-details
        ></v-select>
      </div>
    </div>
    <v-card class="mx-auto normal-card">
      <div class="data-table-section prev-test-tb cat-1">
        <v-data-table
          :headers="headers"
          fixed-header
          :items="testList"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onSortChange="onSortChange"
              :orderBy="orderBy"
            />
          </template>
          <template v-slot:body="{ items }">
            <!-- for institute tests -->
            <tbody v-if="selectedTest == 'institute'">
              <tr v-for="item in items" :key="item.id">
                <td
                  class="text-center rescheduletest"
                  @click="gotoDetailedAnalysis(item)"
                >
                  {{ item.testname }}
                </td>
                <td class="text-left">{{ item.date }}</td>
                <template v-for="(subject, idx) in item.subjects">
                  <td class="text-center" :key="'marks' + idx">
                    {{ subject.marks }}
                  </td>
                  <td class="text-center" :key="'br' + idx">
                    {{ subject.br }}
                  </td>
                  <td class="text-center" :key="'ir' + idx">
                    {{ subject.ir }}
                  </td>
                </template>
                <td class="text-center">{{ item.total.marks }}</td>
                <td class="text-center">{{ item.total.br }}</td>
                <td class="text-center">{{ item.total.ir }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="item in items" :key="item.id">
                <td class="text-center" @click="gotoDetailedAnalysis(item)">
                  {{ item.testname }}
                </td>
                <td class="text-left">{{ item.date }}</td>
                <template v-for="(subject, idx) in item.subjects">
                  <td class="text-center" :key="'marks' + idx">
                    {{ subject.marks }}
                  </td>
                </template>
                <td class="text-center">{{ item.total.marks }}</td>
                <td class="text-center">{{ item.total.air }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <div class="tb-bottom-text">
          <div class="btm-test-prev-left">
            BR: Batch Rank/ IR: Institute Rank
          </div>
          <div class="btm-test-prev-right">
            Click on a test name to see the detailed analysis
          </div>
        </div>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left">
         <v-btn depressed color="indigo" @click="goBack()" class="cumulative-btn">
          Back
        </v-btn>
      </div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

export default {
  name: "TestWiseAnalysis",
  mounted() {
    this.initData();
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalPages: 3,
      orderBy: {
        field: "date_answered",
        order: "DESC",
      },
      testTypesList: [{ text: "Institute Tests", value: "institute" }],
      selectedTest: null,
      headers: [],
      testList: [],
      students: [],
      selectedStudent: [],
      studentId: null,
      isParent: false,
      batchId: null,
    };
  },
  computed: {
    ...mapState("userStore", ["user","myInstitute"]),
  },

  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    ...mapActions({
      getTestWiseAnalysisList: "resultStore/getTestWiseAnalysisList",
    }),
    showTestTypeDD() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      return user && user.role_id === constants.ROLES_ID.ST || user.role_id === constants.ROLES_ID.PA;
    },
    gotoCumulativeAnalysis() {
		let routeName = ""
		if(this.$route.name === "testwise-analysis-coordinator"){
		   routeName = "cumulative-analysis-coordinator"
	   }
	   else if(this.$route.name ==="testwise-analysis-director"){
		   routeName ="cumulative-analysis-director"
	   }
      this.$router.push({
        name: routeName,
        params: { ...this.$route.params, resetPage: true, isCD: true },
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    showCumulativeButton() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      return (
        user &&
        (user.role_id === constants.ROLES_ID.ID ||
          user.role_id === constants.ROLES_ID.CO ||  user.role_id === constants.ROLES_ID.TR )
      );
    },
    defaultData() {
      // this.selectedTest = this.testTypesList[0].value;
      // if (this.types.GOLD === this.user.type) {
        if (this.myInstitute.id === this.ONLINE_INSTITUTE_ID && (this.user.role_id === this.roleIds.ST || this.user.role_id === this.roleIds.PA)) {
          this.testTypesList =[];
          this.testTypesList.push({text: "Self-made Tests", value: "self"},{ text: "Ready-made Tests", value: "premium" });
          
        }else if(!constants.CUSTOM_DOMAIN_ID.includes(this.myInstitute.id)){
          this.testTypesList.push({ text: "Ready-made Tests", value: "premium" }, {text: "Self-made Tests", value: "self"});
        }
      // }
      this.selectedTest = this.testTypesList[0].value;
      let route = this.$route;
      let isCD = route.params.resetPage && route.params.isCD ? true : false;
      let routeName = route.name;
      let crd = this.getCurrentRouteDetails(routeName); 
      if (crd) {
        this.selectedTest =
          crd.selectedTab &&
          !isCD &&
          this.testTypesList.findIndex((x) => x.value === crd.selectedTab) !==
            -1
            ? crd.selectedTab
            : this.testTypesList[0].value;
        this.orderBy =
          crd.tabDetails && crd.tabDetails[crd.selectedTab]
            ? crd.tabDetails[crd.selectedTab].orderBy
            : this.orderBy;
      }
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let details = {
          page: 1,
          orderBy: {
            field: "date_answered",
            order: "DESC",
          },
        };
        let tabDetail = {
          premium: _.cloneDeep(details),
          institute: _.cloneDeep(details),
          self: _.cloneDeep(details),
        };

        let routeDetails = {
          routeName: rp.name,
          selectedTab: crd.selectedTab
            ? crd.selectedTab
            : this.testTypesList[0].value,
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
    },
    updateTestType() {
      this.currentPage = 1;
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd && crd.selectedTab) {
        crd.selectedTab = this.selectedTest;
        this.setRouteDetails(crd);
      }
      this.onPageChange(1);
      // this.requestGetTestList();
    },
    addPremiumType() {
      this.testTypesList.push({
        text: "Premium Tests",
        value: "premium",
      });
    },
    initDataFromUrl() {
      let routeParams = this.$route.params;
      this.batchId = routeParams.batch_id;
      this.studentId = routeParams.student_id;
      // this.selectedTest = this.testTypesList[0].value;
      if (this.types.GOLD === routeParams.type) {
        this.addPremiumType();
      }
      this.requestGetTestList();
    },
    initData() {
      this.checkSessionData();
      this.defaultData();
      if (this.user.role_id == this.roleIds.PA) {
        this.initStudentData();
        this.requestGetTestList();
      } else if (
        this.roleIds.CO === this.user.role_id ||
        this.roleIds.ID === this.user.role_id || this.roleIds.TR === this.user.role_id
      ) {
        this.initDataFromUrl();
      } else {
        this.studentId = this.user.id;
        if (this.types.GOLD === this.user.type) {
          this.addPremiumType();
        }
        // this.selectedTest = this.testTypesList[0].value;
        this.batchId = this.user.batch_id;
        this.requestGetTestList();
      }
    },
    updateSelectedStudent() {
      this.studentId = this.selectedStudent.id;
      this.selectedTest = this.testTypesList[0].value;
      if (this.testTypesList.length == 2) this.testTypesList.pop();
      if (this.types.GOLD === this.selectedStudent.type) {
        this.addPremiumType();
      }
      this.batchId = this.selectedStudent.batchId;

      this.requestGetTestList();
    },
    initStudentData() {
      this.isParent = true;
      this.students = this.user.students.map((student) => {
        let studentObj = {
          text: student.name,
          value: {
            id: student.id,
            batchId: student.batch_id,
            type: student.type,
          },
        };
        return studentObj;
      });
      this.selectedStudent = this.students[0].value;
      this.studentId = this.selectedStudent.id;
      this.batchId = this.selectedStudent.batchId;
      if (this.types.GOLD === this.selectedStudent.type) {
        this.addPremiumType();
      }

    },

    gotoDetailedAnalysis(item) {
      let batch_id = this.batchId;
      let student_test_id = item.studentTestId;
      let test_institute_id = item.testInstituteId;
      let test_name = item.testname;
      let test_id = item.id;
      let selectedTestType = this.selectedTest;
	  let routeName = "response-analysis-coordinator"
	  if(this.$route.name === "testwise-analysis-coordinator"){
		   routeName = "response-analysis-coordinator"
	   }
	    else if(this.$route.name ==="testwise-analysis-director"){
		   routeName ="response-analysis-director"
	   }
      this.$router.push({
        name: routeName,
        params: {
          test_name,
          student_test_id,
          test_institute_id,
          test_id,
          batch_id,
          student_id: this.studentId,
          selectedTestType
        },
      });
    },
    getFormattedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestGetTestList();
    },
    onSortChange() {
      this.requestGetTestList();
    },
    requestGetTestList() {
      let reqData = {
        type: this.selectedTest.toUpperCase(),
        orderBy: this.orderBy,
        student_id: this.studentId,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      this.$root.showLoader = true;
      this.getTestWiseAnalysisList(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.processTestList(response);
          this.totalPages = response.pagination.pageCount;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    generateHeaders(subjects) {
      let colSpan = 1;
      let cols = ["Marks"];
      let totalColSpan = 2;
      let totalColsList = ["Marks", "Expected A.I.R"];
      if (this.selectedTest == "institute") {
        colSpan = 3;
        cols = ["Marks", "BR", "IR"];
        totalColSpan = 3;
        totalColsList = ["Marks", "BR", "IR"];
      }
      let headers = [
        {
          hasColspan: false,
          text: "Test Name",
          hideSort: false,
          value: "name",
          class: "text-center btm-br",
        },
        {
          hasColspan: false,
          text: "Date of Test",
          hideSort: false,
          value: "date_answered",
          class: "text-left btm-br",
        },
      ];
      subjects.forEach((sub) => {
        let subjectObj = {};
        subjectObj.hasColspan = true;
        subjectObj.colSpan = colSpan;
        subjectObj.text = sub.title;
        subjectObj.hideSort = true;
        subjectObj.class = "text-center btm-br";
        subjectObj.cols = cols;
        headers.push(subjectObj);
      });

      headers.push({
        hasColspan: true,
        colSpan: totalColSpan,
        text: "Total",
        hideSort: true,
        class: "text-center btm-br",
        cols: totalColsList,
      });
      this.headers = headers;
    },
    async processTestList(response) {
      let testList = [];
      let allSubjects = response.batch_subjects;
      this.generateHeaders(allSubjects);
      response.list.forEach((test) => {
        let testObj = {};
        testObj.subjects = [];
        testObj.testname = test.test_name;
        testObj.date = this.getFormattedDate(test.date_answered);
        testObj.studentTestId = test.student_test_id;
        testObj.id = test.id;
        testObj.testInstituteId = test.test_institute_id;
        if (this.selectedTest == "institute") {
          testObj.total = {
            marks: test.your_marks,
            br: test.batch_rank,
            ir: test.institute_rank,
          };
        } else {
          testObj.total = {
            marks: test.your_marks,
            air: test.all_india_rank,
          };
        }

        allSubjects.forEach((subject) => {
          // loop on each subject and check if it exists for current student
          let subjectObj = {};
          subjectObj.marks = "-";
          subjectObj.br = "-";
          subjectObj.ir = "-";
          subjectObj.id = subject.id;
          testObj.categoryId = subject.parent;

          let sub = test.subjects.find((s) => s.subject_id == subject.id);
          if (sub) {
            subjectObj.marks = sub.total_marks;
            if (this.selectedTest == "institute") {
              subjectObj.br = sub.batch_rank;
              subjectObj.ir = sub.institute_rank;
            }
          }
          testObj.subjects.push(subjectObj);
        });
        testList.push(testObj);
      });

      this.testList = testList;
    },
  },
  watch: {
    selectedTest(val) {
      let breadCrumb = val == "premium" ? "Ready-made Tests" : val == "self" ? "Self Made Tests" : "Institute Tests";
      this.addBreadCrumbChilde([
        {
          text: this.showCumulativeButton()
            ? 'Test Results'
            : breadCrumb,
          disabled: false,
        },
      ]);
    },
  },
};
</script>
